import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconPerson(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.5 11.5H0.5V10.5C0.5 8.84315 1.84315 7.5 3.5 7.5H8.5C10.1569 7.5 11.5 8.84315 11.5 10.5V11.5Z"
        stroke="currentColor"
      />
      <circle cx="6" cy="3" r="2.5" stroke="currentColor" />
    </SVGIcon>
  );
}
